export const DELETE_INVITATION = 'DELETE_INVITATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const DELETE_MANAGER = 'DELETE_MANAGER';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const DELETE_PATIENT = 'DELETE_PATIENT';
export const DELETE_CLINICIAN = 'DELETE_CLINICIAN';
export const DELETE_SESSION = 'DELETE_SESSION';
export const DELETE_APPOINTMENT_FLOW = 'DELETE_APPOINTMENT_FLOW';
export const DELETE_FIRST_FLOW = 'DELETE_FIRST_FLOW';
export const DELETE_SECOND_FLOW = 'DELETE_SECOND_FLOW';
export const DELETE_THIRD_FLOW = 'DELETE_THIRD_FLOW';
export const DELETE_FIFTH_FLOW = 'DELETE_FIFTH_FLOW';
export const DELETE_SIXTH_FLOW = 'DELETE_SIXTH_FLOW';
export const DELETE_STUDY_FLOW = 'DELETE_STUDY_FLOW';
export const DELETE_SEVENTH_FLOW = 'DELETE_SEVENTH_FLOW';
export const DELETE_WATERFALL_FLOW = 'DELETE_WATERFALL_FLOW';
export const DELETE_FILL_FLOW = 'DELETE_FILL_FLOW';
export const DELETE_FILL_TEMPLATE = 'DELETE_FILL_TEMPLATE';
export const DELETE_ESIGN_FLOW = 'DELETE_ESIGN_FLOW';
export const DELETE_ESIGN_TEMPLATE = 'DELETE_ESIGN_TEMPLATE';
export const DELETE_VOICE_FLOW = 'DELETE_VOICE_FLOW';
export const DELETE_REMINDER_FLOW = 'DELETE_REMINDER_FLOW';
export const DELETE_REFERRAL_FLOW = 'DELETE_REFERRAL_FLOW';
export const DELETE_SCHEDULE_FLOW = 'DELETE_SCHEDULE_FLOW';
export const DELETE_CONFIRM_FLOW = 'DELETE_CONFIRM_FLOW';
export const DELETE_PEN_STUDY_FLOW = 'DELETE_PEN_STUDY_FLOW';
export const DELETE_SUPERBILL_FLOW = 'DELETE_SUPERBILL_FLOW';
export const DELETE_SUPERBILL_GOAL = 'DELETE_SUPERBILL_GOAL';
export const DELETE_BOOK_FLOW = 'DELETE_BOOK_FLOW';
export const DELETE_PATIENT_FLOW = 'DELETE_PATIENT_FLOW';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';